import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Colors from "styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";
const PrevCarouselArrow = ({ isDisabled, color = Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] })=>{
    return /*#__PURE__*/ _jsxs("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Previous item"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807609 11.0711 0.807609 10.4853 1.3934L0.939341 10.9393ZM23 10.5L2 10.5L2 13.5L23 13.5L23 10.5Z",
                fill: isDisabled ? Colors.gainsboro : color
            })
        ]
    });
};
export default PrevCarouselArrow;
